import { Badge } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { BORDER_RADIUS } from 'consts/styles/Main';

const useStyles = makeStyles(theme => ({
  DashboardMain: {
    '&__dashboard': {
      width: 500,
      display: 'block',
      flexDirection: 'column',
      background: 'rgba(11, 17, 32, 0.88)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(14, 165, 233, 0.12)',
      height: 'auto',
      overflowX: 'hidden',
      borderRadius: 8,
      position: 'absolute',
      top: '5vh',
      left: '5vw',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      '&--display-none': {
        display: 'none',
      },
    },
    '&__switcher': {
      width: 400,
      left: 'initial',
      right: '5vw',
      '&__content': {
        padding: 0,
        '&--display-none': {
          display: 'none',
        },
      },
    },
    '&__filters': {
      position: 'absolute',
      bottom: '1vh',
      left: '50%',
      transform: 'translateX(-50%)',
      minWidth: 250,
    },
    '&__content': {
      height: 'calc(100% - 148px)',
      padding: 0,
      paddingTop: 20,
      marginBottom: 70,
      '&--display-none': {
        display: 'none',
      },
    },
  },
}));

const StyledBadge = withStyles(theme => ({
  badge: {
    right: -15,
    top: 5,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))(Badge);

export { useStyles, StyledBadge };
